import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VenereBox } from '../../shared/ui';
import VenereDrop from '../../shared/ui/icons/VenereDrop';
import VenereProgressBar from '../../shared/ui/VenereProgressBar';

interface VenereGLP1BoxProps {

}

export const VenereGLP1Box: React.FC<VenereGLP1BoxProps> = ({
}) => {
    const symptoms = [
        'Nausea',
        'Lieve affaticamento', 
        'Diminuzione appetito',
        'Gonfiore',
    ];

    const [selectedSymptoms, setSelectedSymptoms] = useState<string[]>([]);

    const toggleSymptom = (symptom: string) => {
        setSelectedSymptoms(prev => 
            prev.includes(symptom) 
                ? prev.filter(s => s !== symptom)
                : [...prev, symptom]
        );
    };

    const navigate = useNavigate()

    return (
        <VenereBox variant='matcha' noPadding className="h-full lg:flex lg:flex-col lg:justify-center">
            <div className='flex flex-col gap-2 w-full items-start'>
                {/* Fase 1 */}
                <div className='flex gap-2 items-center p-[10px]'>
                    <div className='flex items-center justify-center venere-bg-royal rounded-[12px] p-[10px]'>
                        <VenereDrop size={45} color='var(--venere-matcha)' />
                    </div>
                    <div className='flex flex-col justify-center'>
                        <div className='venere-text-primary'>Onboarding</div>
                        <div className='venere-text-secondary'>Settimana 2 del trattamento</div>
                    </div>
                </div>

                <div className='flex flex-col gap-2 w-full bg-white p-[10px]'>
                    <div className='w-full flex justify-between'>
                        <div>
                            <div className='venere-text-highlighted'>Ozempic</div>
                            <div className='venere-text-secondary'>0,25 mg/sett</div>
                        </div>
                        <div>
                            <div className='venere-text-secondary !font-bold'>
                                Prossimo step
                            </div>
                            <div className='venere-text-secondary'>0,5 mg/sett</div>
                        </div>
                    </div>
                    <VenereProgressBar 
                        progress={35}
                        className="mt-2"
                    />
                </div>

                <div className='flex flex-col gap-2 w-full venere-bg-matcha p-[10px]'>
                    <div className='w-full space-y-2'>
                        <div className='venere-text-primary'>
                            Hai qualcuno di questi sintomi?
                        </div>
                        <div className='flex flex-wrap gap-2'>
                            {symptoms.map((symptom, index) => {
                                const isSelected = selectedSymptoms.includes(symptom);
                                return (
                                    <button
                                        key={index}
                                        onClick={() => toggleSymptom(symptom)}
                                        className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                                            isSelected 
                                                ? 'bg-[var(--venere-purple)] text-white' 
                                                : 'bg-[var(--venere-lavender)] text-[var(--venere-navy)]'
                                        }`}
                                    >
                                        {symptom}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className='flex flex-col gap-2 w-full venere-bg-seasalt p-[10px] rounded-b-[20px]'>
                    <div className='w-full p-[10px] bg-white'>
                        <div className='venere-text-primary mb-2'>
                            Consigli utili
                        </div>
                        <div className='venere-text-secondary'>
                            Fai l'iniezione dopo un pasto leggero per ridurre la nausea. Idratati e scegli pasti più leggeri e più frequenti.
                        </div>
                    </div>
                </div>
            </div>
        </VenereBox>
    )
};

export default VenereGLP1Box; 